
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/patients/appointments.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { Suspense, useState } from 'react';
import dynamic from 'next/dynamic';
import { Button, Spin } from 'antd';
import useIsRestricted from '@hooks/useIsRestricted';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { css } from '@emotion/react';
import PatientMediaPermissionsWarning from '@components/MediaPermissions/PatientMediaPermissionsWarning';
import { PatientPageHeading, PatientPageSubHeading } from '@components/Layouts/PageHead/PatientPageHeading';
import { ConfirmationModal } from 'vl-common/src/components/Modals';
import { useTranslation } from 'react-i18next';
import TypographyExpandEllipsis from 'vl-common/src/components/UI/ExpandEllipsis';
import Header from '@components/Layouts/Header/Header';

const UpcomingSlider = dynamic(() => import('@components/Upcoming/Slider'));
const AppointmentHistory = dynamic(() => import('@components/Card/AppointmentHistory/AppointmentHistory'));

const PatientsAppointments = () => {
  const initialised = useInitialisedStore();
  const isRestricted = useIsRestricted();
  const [myConditionModal, setMyConditionModal] = useState(false);
  const { t } = useTranslation('common');

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Appointments" />
      <section className="section-layout patient">
        <main className="container" id="page-content">
          <PatientMediaPermissionsWarning />
          <PatientPageHeading>{t('Appointments')}</PatientPageHeading>
          <TypographyExpandEllipsis maxRows={2} paragraphText={t('AppointmentPageDescription')} />
          <PatientPageSubHeading>{t('Upcoming appointments')}</PatientPageSubHeading>
          <div
            className="slider"
            css={css`
              margin: 2em auto;
              max-width: 768px;
            `}
          >
            <Suspense fallback={<Spin />}>{!isRestricted && <UpcomingSlider />}</Suspense>
          </div>
          <PatientPageSubHeading>{t('All appointments')}</PatientPageSubHeading>
          <div>{!isRestricted && <AppointmentHistory />}</div>
        </main>
      </section>
      <ConfirmationModal
        title="My condition"
        open={myConditionModal}
        onCancel={() => setMyConditionModal(false)}
        footer={
          <Button type="primary" onClick={() => setMyConditionModal(false)} data-testid="close">
            {t('Close')}
          </Button>
        }
      >
        {t('Placeholder')}
      </ConfirmationModal>
    </div>
  );
};

export default PatientsAppointments;
export const Route = createFileRoute('/patients/appointments')({ component: PatientsAppointments });
